import { Component, OnInit, ChangeDetectionStrategy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import {SharedModule} from '../@commons/ui-components/shared.module';
import {fadeIn} from '../@commons/animations/animations';
import {
    HeaderPaddingSafeAreaComponent
} from "../@commons/@components/header-padding-safe-area/header-padding-safe-area.component";
import RoutesConstants from '../@commons/constants/routes.constants';
import { GardenTodoStore } from '../@commons/@services/data/garden-todo.store';
import { todoCount } from '../@commons/utils/garden-todo.util';
import { Subscription } from 'rxjs';

/**
 * « Mes tâches » : « À faire » et « Archives », sans compteur dans les
 * onglets ; le sous-titre « n choses à faire » sur les deux. Le jardin est
 * celui de l'app, comme partout ailleurs.
 */
@Component({
    selector: 'vw-agenda',
    imports: [SharedModule, RouterOutlet, TranslatePipe, HeaderPaddingSafeAreaComponent],
    templateUrl: './agenda.component.html',
    styleUrl: './agenda.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [fadeIn],
})
export class AgendaComponent implements OnInit {
  activeTab = 0;
  /** Ce qui reste à faire ; inconnu tant que « Mes tâches » n'a pas répondu. */
  todoCount: number | null = null;
  private countSubscription?: Subscription;

  tabData = [
    { label: 'agenda.tabs.current.tab_title', icon: 'fas fa-home', tailwindClasses: 'text-sm', width: '100%', border: 'rounded-full' },
    { label: 'agenda.tabs.previous.tab_title', icon: 'fas fa-search', tailwindClasses: 'text-sm', width: '100%', border: 'rounded-full' },
  ];

  constructor(private route: ActivatedRoute, private router: Router, private store: GardenTodoStore) {}

  ngOnInit(): void {
    void this.loadTodoCount();
    // Listen to route changes and update activeTab accordingly
    this.route.firstChild?.url.subscribe((urlSegments) => {
      const routePath = urlSegments[0]?.path; // This will give us 'tasks' or 'archives'
      if (routePath === 'tasks') {
        this.activeTab = 0;
      } else if (routePath === 'archives') {
        this.activeTab = 1;
      }
    });
  }

  /** Le compte du sous-titre, pour l'onglet « Archives » aussi. */
  async loadTodoCount(): Promise<void> {
    try {
      this.todoCount = todoCount(await this.store.load(), new Date());
    } catch (e) {
      console.error('AgendaComponent: failed to count tasks', e);
    }
  }

  /** L'onglet « À faire » dit ce qui reste à chaque coche ; « Archives » ne compte rien. */
  onActivate(tab: { countChange?: EventEmitter<number> }): void {
    this.countSubscription = tab.countChange?.subscribe((count) => (this.todoCount = count));
  }

  /** L'onglet quitté (son dernier compte est déjà arrivé, il part avant) : l'abonnement est rendu. */
  onDeactivate(): void {
    this.countSubscription?.unsubscribe();
  }

  onTabSelected(index: number): void {
    this.activeTab = index;

    // Navigate to the appropriate route based on the selected tab index
    if (index === 0) {
      this.router.navigate([RoutesConstants.AGENDA_TASKS]);
    } else if (index === 1) {
      this.router.navigate([RoutesConstants.AGENDA_ARCHIVES]);
    }
  }
}
